import DatasetModal from './DatasetModal.js';
import './DatasetCard.css';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';


function DatasetCard(props) {

    const [isHovering, setIsHovering] = useState(false);
    const [modalIsOpen, setModalOpen] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    }

    const handleMouseOut = () => {
        setIsHovering(false);
    }

    const handleModalOpen = () => {
        setModalOpen(true);
    }

    const handleModalClose = () => {
        setModalOpen(false);
    }

    const { datawrapperLink, datasetName, chartPackageDate } = props.metadataObject;

    const titleColor = isHovering ? '#F2AE00' : '#05436E';

    return (
        <>
            <div
                style={{ 
                    background: '#fff', padding: '4px', marginBottom: '12px'
                }}
            >
                <Button className='dataset-modal-open' onClick={handleModalOpen} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    <h6 className='dataset-card-title' style={{ color: titleColor }}>
                        {datasetName} {chartPackageDate ? `(${chartPackageDate})` : ''}
                    </h6>&nbsp;
                    {isHovering && <i className='las la-hand-pointer' style={{ fontSize: '0.85em', verticalAlign: 'center', color: titleColor }}></i>}
                </Button>
                <div style={{height: '400px', width: '95%', marginBottom: '10px', marginLeft: '5px'}}>
                    <iframe 
                        title={datasetName} src={datawrapperLink} 
                        seamless style={{ height: '100%', width: '0', minWidth: '100%' }}
                        frameBorder="0" data-external="1" loading='lazy'
                    ></iframe>
                </div>
            </div>
            <DatasetModal 
                show={modalIsOpen}
                handleClose={handleModalClose} 
                metadata={props.metadataObject}
            ></DatasetModal>
        </>
    );
}


export default DatasetCard;